import { RadioField, RadioInput } from '@flos/react-ui';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { useRecoilState, useRecoilValue } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import type { CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import { getCoverableIndex } from '../../../../utils/coverablesUtil';
import { useState } from 'react';
import { track } from '../../../../utils/trackingUtil';
import { useHippoText } from '../../../../hooks/useHippoText';

const CatGenderStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const [coverables, setCoverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const getHippoText = useHippoText();

    const { cats = [] } = coverables;
    const coverableIndex = getCoverableIndex(cats, currentProduct.fixedId);
    const coverable = cats[coverableIndex];
    const { gender = '', name = '' } = coverable;
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleCatGenderChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = event.target;

        const updatedCoverables = [...cats];

        updatedCoverables[coverableIndex] = {
            ...updatedCoverables[coverableIndex],
            gender: value
        };

        setCoverables((prev) => ({
            ...prev,
            cats: updatedCoverables
        }));
    };

    const onNext = (): void => {
        setIsLoading(true);
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            cat: {
                publicId: coverable.publicId,
                fixedId: coverable.fixedId,
                gender: coverable.gender
            },
            productToUpdate: currentProduct.flavourName
        };

        void saveCoverableInformation(updatedCoverable).then(() => {
            track(`${coverable.flavourName}CoverableInformationGenderOfCat`, [
                { gender: coverable.gender }
            ]);
            setIsLoading(false);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            onPrevious={goPrevious}
            disableNext={!gender || isLoading}
            isNextLoading={isLoading}
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-PET-COVERABLE-INFORMATION-GENDER-QUESTION', {
                    petname: name ?? ''
                })}
            >
                <RadioField
                    value={gender}
                    onChange={handleCatGenderChange}
                    required
                    disabled={isLoading}
                >
                    <RadioInput value="Female" label="Hun" />
                    <RadioInput value="Male" label="Han" />
                </RadioField>
            </CoverableDetailsTemplate>
        </WizardPagetemplate>
    );
};

export default CatGenderStep;
